import styled from "@emotion/styled";
import { MdsIcon } from "@/design-system/components/icon";
import ColorHash from "color-hash";
import { MDSListBoxItem } from "@/mds/components/lists/list-box-item";

export const StyledListBoxItem = styled(MDSListBoxItem)(
  ({ theme }) => `
  padding: 0 ${theme.spacing.sm};
  border: none;
  margin: 0;
  min-height: 50px;

  &[data-focused] {
    background-color: ${theme.colors.grey.x50};
  }

  &[data-selected] {
    background-color: ${theme.colors.mblue.x50};
  }

  &:hover:not([data-disabled]) {
    background-color: ${theme.colors.grey.x50};
  }
`
);

export const StyledIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`;

const colorHash = new ColorHash({ lightness: 0.5 });

export const StyledCollectionIcon = styled(StyledIconContainer)<{ collectionId: string }>`
  border-radius: 50%;
  background-color: ${({ theme, collectionId }) => {
    if (!collectionId) return theme.colors.grey.x200;

    const [h, s, l] = colorHash.hsl(collectionId);

    return `hsl(${h}, ${s * 100}%, ${l * 100}%)`;
  }};

  /* Ensure icon is white on colored background */
  svg {
    color: white !important;
  }
`;

export const StyledNoteIcon = styled(StyledIconContainer)`
  background-color: ${({ theme }) => theme.colors.grey.x50};
  border-radius: ${({ theme }) => theme.borderRadius.medium}px;

  svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors.grey.x500};
  }
`;

export const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1;
  min-width: 0;
`;

export const StyledTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const StyledTitle = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: ${({ theme }) => theme.lineHeights.small};
  color: ${({ theme }) => theme.colors.grey.x600};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledMetadata = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xsmall};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  line-height: ${({ theme }) => theme.lineHeights.xsmall};
  color: ${({ theme }) => theme.colors.grey.x500};
`;

export const StyledSharedIcon = styled(MdsIcon)`
  width: 12px;
  height: 12px;
  color: ${({ theme }) => theme.colors.grey.x500};
  flex-shrink: 0;
`;
